// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__DJHl2","switch-disabled":"switch_switch-disabled__2LoVg","subLabel":"switch_subLabel__fKzWh","subLabel-view":"switch_subLabel-view__pwQ+Y"};